import React from 'react';

import { Button } from '@eika/button';

import { usePaymentItemDetails } from '../../../fetchHooks/usePaymentItems';
import type { PaymentItem, PaymentItemId } from '../../../generated-types';
import { useActorReceiver } from '../../../hooks/useSetReceiver';
import useTranslation from '../../../hooks/useTranslation';
import { ErrorCardWrapper } from '../../shared/ErrorCardWrapper';
import PaymentItemDetailsForm from './PaymentItemDetailsForm';
import PaymentItemDetailsSkeleton from './PaymentItemDetailsSkeleton';

interface Props {
    id: PaymentItemId | undefined;
    paymentItem: PaymentItem | undefined;
    onClose: () => void;
}

const PaymentItemModalContent: React.FC<Props> = ({ id, paymentItem, onClose }) => {
    const translated = useTranslation();

    const {
        data: paymentDetails,
        error,
        isLoading: isLoadingPaymentDetails,
        refetch: refreshDetails,
    } = usePaymentItemDetails(id, { enabled: paymentItem?.permissions?.canView });

    const receiver = useActorReceiver(paymentDetails?.receiver ?? paymentItem?.receiver);
    const isLoading = isLoadingPaymentDetails || !receiver;

    if (!paymentItem || !id) return null;

    if (error && !isLoading) {
        return (
            <ErrorCardWrapper className="payment-item__error-view" exception={error}>
                <Button onClick={() => refreshDetails()}>{translated.tryAgain}</Button>
            </ErrorCardWrapper>
        );
    }

    if (isLoading) {
        return <PaymentItemDetailsSkeleton />;
    }

    return (
        <PaymentItemDetailsForm
            paymentDetails={paymentDetails}
            toAccount={receiver}
            paymentItem={paymentItem}
            onClose={onClose}
        />
    );
};

export default PaymentItemModalContent;
